<template>
    <v-container class="px-0">
      CMS
      <router-view></router-view> 
    </v-container>
   
</template>
<script>
  export default {
    name: 'CMS',

    components: {
      
    },

    data: () => ({

    }),
    created: function () {
      console.log("Componente creado")
    },
    mounted: function () {
      console.log("Componente mondado")
    },
    methods: {
    },
    computed: {
      
    },
  }
</script>
<style scoped>
</style>
